import { FC, Fragment } from "react";
import useTableConfigTax, { Props } from "./hook";
import { Styles } from "./styled";
import { Form, Table } from "antd";

const TableConfigTaxLayout: FC<Props> = ({
  dataSource,
  columns,
  expandedKeys,
  isLoading,
  form,
  displaySize,
}) => {
  return (
    <Styles text_scale={displaySize}>
      <h2 className="title-button">雇用保険料率更新</h2>
      <Form form={form}>
        <Table
          scroll={{ x: 800 }}
          style={{ maxWidth: 1200 }}
          loading={isLoading}
          showHeader={false}
          columns={columns}
          dataSource={dataSource}
          expandable={{
            expandedRowKeys: expandedKeys,
          }}
          pagination={false}
        />
        {dataSource.map((data) => {
          return data.children?.map((itemChild, index) => {
            return (
              <Fragment key={index}>
                <Form.Item
                  key={itemChild.id.toString() + "insurance_tax"}
                  name={[
                    itemChild.industry_category_id.toString(),
                    itemChild.id.toString(),
                    "insurance_tax",
                  ]}
                  hidden
                />

                <Form.Item
                  key={itemChild.id.toString() + "start_date"}
                  name={[
                    itemChild?.industry_category_id.toString(),
                    itemChild.id.toString(),
                    "start_date",
                  ]}
                  hidden
                />
              </Fragment>
            );
          });
        })}
      </Form>
    </Styles>
  );
};

const TableConfigTax: FC = () => (
  <TableConfigTaxLayout {...useTableConfigTax()} />
);

export default TableConfigTax;
